<button [class]="buttonType" [disabled]="isDisabled" (click)="onClick()">
    {{ buttonTitle }}
    {{ showProgress && file?.progress ? file?.progress + '%' : '' }}
    <fun-icon [name]="'upload'" [style]="'w-24 h-24 stroke-[4px] stroke-[#29141F] pl-[10px]'"></fun-icon>
</button>
<input type="file" #fileUpload id="fileUpload" name="fileUpload" multiple="multiple" [accept]="buttonAccept" style="display:none;" />